import maplibregl from 'maplibre-gl';


export function createInsetMap(config, initialCenter) {
    return new maplibregl.Map({
        container: 'mapInset',
        style: config.style,
        center: initialCenter,
        zoom: 3,
        hash: false,
        interactive: false,
        attributionControl: false
    });
}

export function getInsetBounds(mainMap) {
    const bounds = mainMap.getBounds();

    return {
        "type": "FeatureCollection",
        "features": [{
            "type": "Feature",
            "properties": {},
            "geometry": {
                "type": "Polygon",
                "coordinates": [[
                    [bounds._sw.lng, bounds._sw.lat],
                    [bounds._ne.lng, bounds._sw.lat],
                    [bounds._ne.lng, bounds._ne.lat],
                    [bounds._sw.lng, bounds._ne.lat],
                    [bounds._sw.lng, bounds._sw.lat]
                ]]
            }
        }]
    };
}


export function addInsetLayer(insetMap, boundsGeoJSON) {
    insetMap.addSource('boundsSource', {
        type: 'geojson',
        data: boundsGeoJSON
    });

    insetMap.addLayer({
        id: 'boundsLayer',
        type: 'fill',
        source: 'boundsSource',
        layout: {},
        paint: {
            'fill-color': '#fff',
            'fill-opacity': 0.2
        }
    });

    insetMap.addLayer({
        id: 'outlineLayer',
        type: 'line',
        source: 'boundsSource',
        layout: {},
        paint: {
            'line-color': '#000',
            'line-width': 1
        }
    });
}


export function updateInsetLayer(insetMap, boundsGeoJSON) {
    insetMap.getSource('boundsSource').setData(boundsGeoJSON);
}
